import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Experience } from "@/components/Experience";
import { Projects } from "@/components/Projects";
import { Certifications } from "@/components/Certifications";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Recommendations } from "@/components/Recommendations";
import { Skills } from "@/components/Skills";
import { Contact } from "@/components/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <Experience />
      <Projects />
      <EditorialMarquee />
      <Certifications />
      <Recommendations />
      <Skills />
      <Contact />
    </main>
  );
}

export { Nav };
